import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 219 175.2"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M219 19.3c0 10.7-8.6 19.3-19.3 19.3-10.7 0-19.3-8.6-19.3-19.3C180.3 8.6 189 0 199.6 0c10.7 0 19.3 8.6 19.3 19.3ZM10.3 48.8h52.1c5.1 0 9 1.7 10.5 8.9 1.7 8.1 1 13.7-8.1 14.3l-16.4 1.2c12.1 76 82.4 100.8 120.7 18.9 6.3-13.5 8.4-16 15.4-14.3 9.4 2.3 10.7 7.2 6.2 20.8C157.6 199.5 46.4 209.7 24.5 74.9l-13.2 1C.4 76.6 0 67.5 0 62.5c0-10.1 3.7-13.7 10.3-13.7Z",
      style: {"fill":"#d40e14"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "6B-logo"}) } }